








import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class GoBackButton extends Vue {
  goBack() {
    this.$router.go(-1);
  }
}
